import { ImaPlugin, VideoJsPlayer } from 'video.js';

abstract class Base {
  protected getImaInstance(vjsPlayer: VideoJsPlayer) {
    return vjsPlayer.usingPlugin('ima')
      ? (vjsPlayer.ima as ImaPlugin)
      : undefined;
  }
}

export default Base;
